import './i18n.polyfill'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { CommonB2CProvider } from '@masfront/common-b2c'
import i18n, { I18nProvider } from '@masfront/common-i18n'
import { AppShell } from '@masfront/common-ui'
import { Persistor } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'

import useAuth from '~/auth/hooks/useAuth'
import { useBrand, getTheme } from '~/brand'
import { AppDepsContext } from '~/core/hooks/useAppDepsContext'
import AppDeps from '~/core/model/AppDeps'
import { selectFeatureFlags } from '~/featureFlags'
import { useFeatureFlagsSync, useRemoteFlagsInitAndUp } from '~/featureFlags/hooks'
import InitRoutes from '~/pages/router/InitRoutes'
import GlobalStyles from '~/ui/GlobalStyles'

interface AppProps {
  appDeps: AppDeps
  persistor: Persistor
}

export default function App({ persistor, appDeps }: AppProps) {
  const { brand } = useBrand()
  const theme = getTheme(brand)

  useAuth(appDeps.authService)
  useFeatureFlagsSync()
  useRemoteFlagsInitAndUp()

  // Detect changes on featureFlags and  rerender
  useSelector(selectFeatureFlags)

  useEffect(() => {
    i18n.setLocale('es')
  }, [])

  return (
    // TODO: look for better types
    <PersistGate loading={null} persistor={persistor}>
      <AppDepsContext.Provider value={appDeps}>
        <BrowserRouter>
          <AppShell theme={theme}>
            <GlobalStyles theme={theme} />
            <CommonB2CProvider>
              <I18nProvider>
                <I18nProvider>
                  <InitRoutes />
                </I18nProvider>
              </I18nProvider>
            </CommonB2CProvider>
          </AppShell>
        </BrowserRouter>
      </AppDepsContext.Provider>
    </PersistGate>
  )
}
